import React from "react";
import Layout from "@/landing/template";
import Head from 'next/head'
import getContents from "@helper/util/landing/getContents";

const Landing = () => {
  const { contents, language } = getContents();
  
  return (
    <>
      <Head
        title="SellOn | Home"
        type="website"
        url="https://sellon.net"
        siteName="Sellon Tech"
        image="/media/logo/main.png"
      />

      <Layout contents={contents} language={language} />
    </>
  );
};

export default Landing;